import { mapState, useStore } from "vuex";
import { env } from "md-base-tools/env";
import DialogBtn from "@/components/order_detail/dialogBtn";
import detailsStatus from "@@/order_detail/detailsStatus.vue";
import detailsAddress from "@@/order_detail/detailsHeaderAddress.vue";
import lowerdev from "@/service/lowerdev";
import { useRoute } from "vue-router";
import ClipboardJS from "clipboard";
// eslint-disable-next-line no-unused-vars
import { postOrder, get, post } from "@/utils/apiBase.js";
import { showSuccessToast, showToast } from "vant";

//  获取众筹解锁单详情
import { getProLockOrderDetail } from "@api/index";
import lockRelateOrderList from "@@/order_detail/lockRelateOrderList.vue";
import lockRelateAddressList from "@@/order_detail/lockRelateAddressList.vue";
export default {
  data() {
    return {
      env: env,
      show: true,
      isMobile: env.isMobile(),
      copyboard: null,
      dialog_show: false,
      miniProgram: false,
      dialog_btn: [],
      originInfo: {
        // 关联订单信息
        origin_order: {
          num: 0,
          title: '',
          orders: []
        }
      },
      showRelatedOrders: false,
      // 控制关联订单弹窗显示
      showAddress: false,
      // 控制切换地址弹窗显示
      isScrollEnd: false,
      requestParams: {},
      isFix: 0
    };
  },
  components: {
    detailsStatus,
    DialogBtn,
    detailsAddress,
    lockRelateOrderList,
    lockRelateAddressList
  },
  async setup() {
    const route = useRoute();
    let orderId = route.query.order_id || "";
    const store = useStore();

    // 获取URL中的所有查询参数
    const allQueryParams = {
      ...route.query
    };
    console.log('requestParams-------->', allQueryParams);
    const res = await getProLockOrderDetail(allQueryParams);
    if (res.status !== 0) {
      return showToast({
        type: "text",
        message: res.message,
        onClose: () => {
          window.history.back();
        }
      });
    }
    const orderInfo = res.data;

    // 数组拼接为三倍

    // const sku_vos = orderInfo.sku_vos;
    // sku_vos.push(sku_vos);
    //   sku_vos.push(sku_vos);
    //   sku_vos.push(sku_vos);
    //   sku_vos.push(sku_vos);
    //   sku_vos.push(sku_vos);
    //   sku_vos.push(sku_vos);
    // orderInfo.sku_vos = sku_vos;

    console.log('orderInfo.btn_list', orderInfo.btn_list);
    orderInfo.order_btns = orderInfo.btn_list;
    console.log('orderInfo.order_btns', orderInfo.order_btns);
    console.log('orderInfo', orderInfo);

    // 定义在setup中的刷新方法
    const refreshOrderDetail = async () => {
      console.log('刷新订单数据...');
      // 重新获取订单详情
      const refreshRes = await getProLockOrderDetail(allQueryParams);
      if (refreshRes.status === 0) {
        // 处理refreshRes.data，更新orderInfo的数据
        Object.assign(orderInfo, refreshRes.data);
        orderInfo.order_btns = orderInfo.btn_list;

        // 更新store数据
        store.commit("setValue", {
          obj: "info",
          value: orderInfo
        });
        console.log('订单数据刷新成功', orderInfo);
      } else {
        showToast({
          type: "text",
          message: refreshRes.message || '刷新数据失败'
        });
      }
    };
    orderId = orderInfo.order_id;
    store.commit("setValue", {
      obj: "info",
      value: orderInfo
    });
    return {
      orderId,
      orderInfo,
      refreshOrderDetail // 返回setup中定义的刷新函数
    };
  },
  watch: {
    $route() {}
  },
  mounted() {
    const route = useRoute();
    // 获取URL中的所有查询参数
    const allQueryParams = {
      ...route.query
    };
    console.log('requestParams-------->', allQueryParams);
    if (!this.if_no_header) {
      document.querySelectorAll(".details-box")[0].setAttribute("class", "details-box viewBox");
    }
    document.body.style.background = "#f2f2f2";
    if (sessionStorage.getItem("miniProgram") === "weixin") {
      lowerdev.dynamicScript("https://res.wx.qq.com/open/js/jweixin-1.4.0.js");
    }
    var target = this.$refs.copy;
    this.copyboard = new ClipboardJS(target, {
      text(target) {
        return target.getAttribute("copyData");
      }
    });
    // eslint-disable-next-line no-undef
    userHeader.backnavOnShow(false);
    this.copyboard.on("success", () => {
      // eslint-disable-next-line
      showSuccessToast("复制成功");
    });
    document.addEventListener("visibilitychange", function () {
      // 此代码块可保留，但删除openwxmina相关逻辑
      if (document.visibilityState === "visible") {
        // 检查页面可见性变化，可保留
      }
    });
  },
  beforeUnmount() {
    document.body.style.background = "#f8f8f8";
  },
  computed: {
    ...mapState({
      userId: state => state.user.userId
    }),
    if_show() {
      return !(this.env.isWeibo() || this.env.isWeixin() || this.env.isModianIos() || this.env.isModianAndroid());
    },
    if_no_header() {
      return !(this.isMobile || this.env.isModianIos() || this.env.isModianAndroid()) || this.env.isWeibo();
    },
    gift_send_type() {
      switch (Number(this.orderInfo.type)) {
        case 1:
          return '每个用户赠送一次';
        case 2:
          return '每个订单赠送一次';
        case 3:
          return '每份回报档赠送一次';
        default:
          return '未知';
      }
    }
  },
  methods: {
    async requestOrderDetail() {},
    op(btn) {
      // eslint-disable-next-line eqeqeq
      console.log('btn------->', btn);
      // eslint-disable-next-line no-case-declarations
      switch (btn.type) {
        case "update_address":
          // 确认修改地址
          this.showAddress = true;
          break;
        default:
          return false;
      }
    },
    // 显示更多弹窗
    show_dialog(e) {
      this.dialog_btn = JSON.parse(JSON.stringify(e));
      this.dialog_show = true;
    },
    close_dialog() {
      this.dialog_show = false;
    },
    copy() {
      var target = this.$refs.copy;
      this.copyboard = new ClipboardJS(target, {
        text(target) {
          return target.getAttribute("copyData");
        }
      });
      this.copyboard.on("success", () => {
        // eslint-disable-next-line
        showSuccessToast("复制成功");
      });
    },
    viewMoreOrders() {
      // 显示关联订单弹窗
      this.showRelatedOrders = true;
    },
    getOrderImage(order) {
      // 获取订单图片，默认使用占位图
      if (order && order.image_url) {
        return order.image_url;
      }
      return "";
    },
    handleScroll(event) {
      const container = event.target;
      // 判断是否滚动到最右侧
      // scrollLeft是当前滚动位置，scrollWidth是总宽度，clientWidth是可视区域宽度
      const isEnd = Math.ceil(container.scrollLeft + container.clientWidth) >= container.scrollWidth - 5; // 添加5px的容差

      this.isScrollEnd = isEnd;
      console.log(this.isScrollEnd);
    },
    //是否吸顶
    handleStickyAction(is_fix) {
      this.isFix = is_fix ? 1 : 0;
      console.log('isFix.value-----', this.isFix);
    }
  }
};